import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { showAlertSnackbar } from '@juvare/common-web-ui/SnackbarHelper';
import { showDirectoryTreeDialog } from '../../features/file-manager';
import { showReviewAccessPermissionsDialog } from './showReviewAccessPermissionsDialog';
export function showMoveDialog(params) {
    const handleMove = (directory) => {
        params.storage
            .post({ action: 'partial-update', id: params.file.id, data: {}, parentId: directory === null || directory === void 0 ? void 0 : directory.id, updateParentId: true })
            .then((response) => {
            showAlertSnackbar({
                horizontalPosition: 'center',
                type: 'success',
                verticalPosition: 'bottom',
                autoHideDuration: 2000,
                message: params.t('moveDialog.movedSnackbar', { fileEntityType: params.fileEntityType }),
            });
            params.onSuccess(response, directory === null || directory === void 0 ? void 0 : directory.id);
        })
            .catch((error) => {
            if (error.type === 'entity-circular-parent-reference') {
                handleErrorDialog(params.t('moveDialog.circularParentReferenceError'));
            }
            else {
                handleErrorDialog(error);
            }
        });
    };
    showDirectoryTreeDialog({
        showRootDirectory: params.showRootDirectory,
        title: params.t('documentPanel.selectNewLocation'),
        onChange: (directory) => {
            showReviewAccessPermissionsDialog({
                onContinue: () => handleMove(directory),
                action: 'move',
            });
        },
    });
}
